/* eslint no-console: 0 */
import Vue from 'vue/dist/vue.esm'
import App from '../../javascripts/application/shop/basket.vue'
import store from '../../javascripts/application/shop/store.js'

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    el: '#basket',
    store,
    render: h => h(App),
    components: { App }
  })
})
